import React from "react";
import styles from "../styles.module.scss";
import formatter from "../../utils/compactCurrencyFormatter";

const Tooltip = React.memo(({ data, x: tooltipX, y: tooltipY }) => {
  if (!data) return null;
  const { mcc, percentage, description, count, total_sales, color } = data;

  return (
    <div
      className={styles.tooltipContainer}
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        transform: `translate(${tooltipX}px, ${tooltipY}px)`,
        backgroundColor: "#fff",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        fontSize: "12px",
        zIndex: 100,
        pointerEvents: "none",
      }}
    >
      <div className={styles.valueContainer}>
        <span className={styles.value}>{mcc}</span>
        <span className={styles.valuePercentage}>{percentage}%</span>
      </div>
      <div className={`${styles.listItem} ${styles.listItemIndustry}`}>
        <div
          className={`${styles.listItemLabel} ${styles.listItemLabelIndustry}`}
        >
          <span
            className={styles.listItemCircle}
            style={{ backgroundColor: color }}
          ></span>
          {description}
        </div>
        <span className={styles.listItemValue}>{count} MIDs</span>
      </div>
      <div className={styles.listItem}>
        <span className={styles.listItemLabel}>Sales volume</span>
        <span className={styles.listItemValue}>
          {formatter.format(total_sales)}
        </span>
      </div>
    </div>
  );
});

Tooltip.displayName = "TooltipContent";

export default Tooltip;
